import type { Buffer } from "./buffer";
import { lastLineIndex, lastNormalModeCol } from "./buffer";

export interface Cursor {
  readonly line: number;
  readonly col: number;
}

export function createCursor(line: number, col: number): Cursor {
  return { line, col };
}

/** カーソルがバッファ範囲内（ノーマルモードの列制約込み）に収まるようクランプする。 */
export function clampCursor(buffer: Buffer, cursor: Cursor): Cursor {
  const line = Math.min(Math.max(cursor.line, 0), lastLineIndex(buffer));
  const col = Math.min(Math.max(cursor.col, 0), lastNormalModeCol(buffer, line));
  return { line, col };
}
